export enum Breakpoint {
  MOBILE = 460,
  TABLET = 768,
  DESKTOP = 1024,
  // TODO: https://gitlab.io.thehut.local/thg-society/influencer-platform/-/merge_requests/4153#note_2213970
  TEMP_1500 = 1500,
  TEMP_1900 = 1900,
}
